import {AnimatePresence, AnimationProps, motion} from "framer-motion";
import {FC, PropsWithChildren} from "react";

const AnimatedAccordion: FC<
  PropsWithChildren & {condition: boolean; animatiionProps?: AnimationProps; className?: string}
> = ({children, condition, animatiionProps = {}, className}) => {
  return (
    <AnimatePresence initial={false}>
      {condition && (
        <motion.div
          key="content"
          className={className}
          initial={{height: 0, opacity: 0}}
          animate={{height: "auto", opacity: 1}}
          exit={{height: 0, opacity: 0}}
          transition={{duration: 0.3, ease: "easeInOut"}}
          {...animatiionProps}>
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AnimatedAccordion;
